import * as React from 'react';
import { Button } from '@gandi/ui';
import { Static } from '../Static';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Maintenance({
  translator: {
    __
  },
  assetPath,
  locale,
  backLink,
  ...extraProps
}) {
  return /*#__PURE__*/_jsxs(Static, {
    title: __('Maintenance in progress'),
    illustration: assetPath('img/Maintenance.svg'),
    buttons: backLink && /*#__PURE__*/_jsx(Button, {
      href: backLink,
      children: __('Return to homepage')
    }),
    ...extraProps,
    children: [/*#__PURE__*/_jsx("p", {
      children: __('We are currently doing maintenance work on the service ' + 'you requested.')
    }), /*#__PURE__*/_jsx("p", {
      children: __('Please try again at a later moment.')
    }), /*#__PURE__*/_jsx("p", {
      dangerouslySetInnerHTML: __('You can also access  ' + '<a href="https://status.gandi.net">status.gandi.net</a> ' + 'for more information about the current state of our plateform.', {
        withHTML: true
      })
    })]
  });
}
export default Maintenance;